import API from './axios.js';


export const saveLabel = (labelData) => API.post('label', labelData);
export const getLabelsByUser = (queryParams = '') => API.get(`label${queryParams}`);
export const getLabelsByID = (labelId) => API.get(`label/${labelId}`);
export const updateLabel = (labelId , labelData ) => API.patch(`label/${labelId}`,labelData);
export const deleteLabel = (id) => API.delete(`label/${id}`);